module.exports = __webpack_public_path__ + "static/img/img-p3-3gs.d1a3059e.jpg";